// Mock data per il SaaS finanziario

export const currentUser = {
  id: 1,
  name: "Marco Rossi",
  email: "marco.rossi@company.com",
  role: "Senior Advisor"
};

export const staff = [
  { 
    id: 1, 
    name: "Marco Rossi", 
    role: "Senior Advisor", 
    email: "marco.rossi@company.com", 
    phone: "+39 02 5551 1234", 
    tipoPersonale: "interno",
    skills: ["Consulenza Fiscale", "Pianificazione Patrimoniale", "M&A"],
    activeAssignments: ["Analisi patrimoniale Marini", "Due diligence Costa"],
    completedAssignments: ["Consulenza fiscale Galli", "Revisione contratti Ricci"]
  },
  { 
    id: 2, 
    name: "Laura Bianchi", 
    role: "Financial Analyst", 
    email: "laura.bianchi@company.com", 
    phone: "+39 06 5552 5678", 
    tipoPersonale: "interno",
    skills: ["Analisi Finanziaria", "Budget & Forecast", "Reporting"],
    activeAssignments: ["Report trimestrale Q2", "Analisi costi Lombardi"],
    completedAssignments: ["Budget 2025", "Analisi investimenti Costa"]
  },
  { 
    id: 3, 
    name: "Giuseppe Verdi", 
    role: "Account Manager", 
    email: "giuseppe.verdi@company.com", 
    phone: "+39 011 5553 9012", 
    tipoPersonale: "interno",
    skills: ["Gestione Clienti", "Negoziazione", "Business Development"],
    activeAssignments: ["Follow-up cliente Galli"],
    completedAssignments: ["Onboarding Costa Holding", "Rinnovo contratto Marini", "Presentazione servizi Ricci"]
  },
  { 
    id: 4, 
    name: "Sofia Romano", 
    role: "Legal Advisor", 
    email: "sofia.romano@company.com", 
    phone: "+39 051 5554 3456", 
    tipoPersonale: "esterno",
    skills: ["Diritto Societario", "Contrattualistica", "Compliance"],
    activeAssignments: ["Revisione contratti Ricci", "Parere legale Lombardi"],
    completedAssignments: ["Due diligence legale Costa", "Contratto consulenza Marini"]
  },
  { 
    id: 5, 
    name: "Andrea Ferrari", 
    role: "Tax Consultant", 
    email: "andrea.ferrari@company.com", 
    phone: "+39 02 5555 7890", 
    tipoPersonale: "esterno",
    skills: ["Fiscalità Internazionale", "Tax Planning", "Transfer Pricing"],
    activeAssignments: ["Pianificazione fiscale Lombardi", "Ottimizzazione imposte Costa"],
    completedAssignments: ["Dichiarazione redditi Marini", "Consulenza IVA Galli"]
  }
];

export const clients = [
  { 
    id: 1, 
    name: "Giovanni Marini", 
    company: "Marini S.r.l.", 
    referredBy: "Laura Bianchi", 
    phone: "+39 02 1234 5678", 
    email: "g.marini@marini.it",
    vatNumber: "IT12345678901",
    sector: "Consulenza",
    businessName: "Marini Società a Responsabilità Limitata",
    numeroREA: "MI-2045678",
    codiceFiscale: "MRNGNN75A01F205K",
    formaGiuridica: "S.r.l.",
    indirizzoSedeLegale: "Via Milano 45, 20121 Milano (MI)",
    tipoCliente: "cedente",
    contattiPersonali: {
      email: "giovanni.marini@gmail.com",
      phone: "+39 335 1234567"
    },
    contattiAziendali: {
      email: "info@marini.it",
      phone: "+39 02 1234 5678"
    },
    documenti: [
      { id: 1, nome: "Visura Camerale 2025.pdf", tipo: "visura", dataCaricamento: "2025-01-10", dimensione: "1.2 MB" },
      { id: 2, nome: "Bilancio 2024.pdf", tipo: "bilancio", dataCaricamento: "2025-01-05", dimensione: "3.5 MB" }
    ]
  },
  { 
    id: 2, 
    name: "Francesca Costa", 
    company: "Costa Holding", 
    referredBy: "Marco Rossi", 
    phone: "+39 06 9876 5432", 
    email: "f.costa@costaholding.it",
    vatNumber: "IT98765432109",
    sector: "Investimenti",
    businessName: "Costa Holding S.p.A.",
    numeroREA: "RM-1523456",
    codiceFiscale: "98765432109",
    formaGiuridica: "S.p.A.",
    indirizzoSedeLegale: "Via Roma 120, 00185 Roma (RM)",
    tipoCliente: "cessionario",
    contattiPersonali: {
      email: "francesca.costa@outlook.com",
      phone: "+39 339 8765432"
    },
    contattiAziendali: {
      email: "segreteria@costaholding.it",
      phone: "+39 06 9876 5400"
    },
    documenti: [
      { id: 1, nome: "Statuto Societario.pdf", tipo: "statuto", dataCaricamento: "2024-12-15", dimensione: "2.1 MB" }
    ]
  },
  { 
    id: 3, 
    name: "Roberto Galli", 
    company: "Galli & Partners", 
    referredBy: "Giuseppe Verdi", 
    phone: "+39 011 2468 1357", 
    email: "r.galli@gallipartners.com",
    vatNumber: "IT11223344556",
    sector: "Gestione Patrimoniale",
    businessName: "Galli & Partners S.r.l.",
    numeroREA: "TO-0987654",
    codiceFiscale: "GLLRRT68M15L219X",
    formaGiuridica: "S.r.l.",
    indirizzoSedeLegale: "Corso Vittorio Emanuele II 89, 10128 Torino (TO)",
    tipoCliente: "cedente",
    contattiPersonali: {
      email: "",
      phone: "+39 347 2468135"
    },
    contattiAziendali: {
      email: "info@gallipartners.com",
      phone: "+39 011 2468 1357"
    },
    documenti: []
  },
  { 
    id: 4, 
    name: "Elena Ricci", 
    company: "Ricci Invest", 
    referredBy: "Sofia Romano", 
    phone: "+39 051 3691 2580", 
    email: "e.ricci@ricciinvest.eu",
    vatNumber: "IT66778899001",
    sector: "Real Estate",
    businessName: "Ricci Invest S.r.l.",
    numeroREA: "BO-0654321",
    codiceFiscale: "RCCLNE80D55A944T",
    formaGiuridica: "S.r.l.",
    indirizzoSedeLegale: "Via Indipendenza 32, 40121 Bologna (BO)",
    tipoCliente: "altro",
    contattiPersonali: {
      email: "elena.ricci@libero.it",
      phone: ""
    },
    contattiAziendali: {
      email: "commerciale@ricciinvest.eu",
      phone: "+39 051 3691 2580"
    },
    documenti: [
      { id: 1, nome: "Certificato Attribuzione P.IVA.pdf", tipo: "certificato", dataCaricamento: "2025-01-08", dimensione: "0.5 MB" },
      { id: 2, nome: "DURC.pdf", tipo: "durc", dataCaricamento: "2025-01-12", dimensione: "0.8 MB" },
      { id: 3, nome: "Contratto Quadro.pdf", tipo: "contratto", dataCaricamento: "2025-01-15", dimensione: "1.8 MB" }
    ]
  },
  { 
    id: 5, 
    name: "Marco Lombardi", 
    company: "Lombardi Capital", 
    referredBy: "Andrea Ferrari", 
    phone: "+39 02 7531 9864", 
    email: "m.lombardi@lombardicap.it",
    vatNumber: "IT55443322110",
    sector: "Finanza",
    businessName: "Lombardi Capital S.p.A.",
    numeroREA: "MI-1876543",
    codiceFiscale: "55443322110",
    formaGiuridica: "S.p.A.",
    indirizzoSedeLegale: "Piazza Duomo 1, 20122 Milano (MI)",
    tipoCliente: "cessionario",
    contattiPersonali: {
      email: "marco.lombardi@me.com",
      phone: "+39 348 7531986"
    },
    contattiAziendali: {
      email: "direzione@lombardicap.it",
      phone: "+39 02 7531 9800"
    },
    documenti: [
      { id: 1, nome: "Visura Camerale 2025.pdf", tipo: "visura", dataCaricamento: "2025-01-11", dimensione: "1.4 MB" }
    ]
  },
  { 
    id: 6, 
    name: "Paolo Manfredi", 
    company: "Manifatture Rossi S.p.A.", 
    referredBy: "Marco Rossi", 
    phone: "+39 02 8765 4321", 
    email: "p.manfredi@manifatturerossi.it",
    vatNumber: "IT22334455667",
    sector: "Manifatturiero",
    businessName: "Manifatture Rossi S.p.A.",
    numeroREA: "MI-2234567",
    codiceFiscale: "22334455667",
    formaGiuridica: "S.p.A.",
    indirizzoSedeLegale: "Via Industria 100, 20090 Assago (MI)",
    tipoCliente: "cedente",
    contattiPersonali: {
      email: "paolo.manfredi@gmail.com",
      phone: "+39 340 8765432"
    },
    contattiAziendali: {
      email: "amministrazione@manifatturerossi.it",
      phone: "+39 02 8765 4300"
    },
    documenti: []
  },
  { 
    id: 7, 
    name: "Luca Verde", 
    company: "EcoEnergy S.p.A.", 
    referredBy: "Giuseppe Verdi", 
    phone: "+39 055 1234 5678", 
    email: "l.verde@ecoenergy.it",
    vatNumber: "IT33445566778",
    sector: "Energia Rinnovabile",
    businessName: "EcoEnergy S.p.A.",
    numeroREA: "FI-1122334",
    codiceFiscale: "33445566778",
    formaGiuridica: "S.p.A.",
    indirizzoSedeLegale: "Via della Sostenibilità 25, 50100 Firenze (FI)",
    tipoCliente: "cedente",
    contattiPersonali: { email: "", phone: "+39 333 1234567" },
    contattiAziendali: { email: "info@ecoenergy.it", phone: "+39 055 1234 5678" },
    documenti: []
  },
  { 
    id: 8, 
    name: "Anna Startup", 
    company: "TechStart S.r.l.", 
    referredBy: "Laura Bianchi", 
    phone: "+39 02 9999 8888", 
    email: "a.startup@techstart.io",
    vatNumber: "IT44556677889",
    sector: "Tecnologia",
    businessName: "TechStart S.r.l.",
    numeroREA: "MI-3344556",
    codiceFiscale: "44556677889",
    formaGiuridica: "S.r.l.",
    indirizzoSedeLegale: "Via Innovation 10, 20145 Milano (MI)",
    tipoCliente: "cedente",
    contattiPersonali: { email: "anna.startup@icloud.com", phone: "+39 349 9998888" },
    contattiAziendali: { email: "hello@techstart.io", phone: "+39 02 9999 8888" },
    documenti: []
  },
  { 
    id: 9, 
    name: "Carlo Bianchi", 
    company: "GlobalTrade Inc.", 
    referredBy: "Andrea Ferrari", 
    phone: "+39 06 7777 6666", 
    email: "c.bianchi@globaltrade.com",
    vatNumber: "IT55667788990",
    sector: "Import/Export",
    businessName: "GlobalTrade Inc.",
    numeroREA: "RM-4455667",
    codiceFiscale: "55667788990",
    formaGiuridica: "S.r.l.",
    indirizzoSedeLegale: "Via del Commercio 50, 00144 Roma (RM)",
    tipoCliente: "cessionario",
    contattiPersonali: { email: "", phone: "" },
    contattiAziendali: { email: "sales@globaltrade.com", phone: "+39 06 7777 6666" },
    documenti: []
  },
  { 
    id: 10, 
    name: "Maria Industria", 
    company: "Industrie Meridionali", 
    referredBy: "Sofia Romano", 
    phone: "+39 081 5555 4444", 
    email: "m.industria@indmerid.it",
    vatNumber: "IT66778899001",
    sector: "Industria",
    businessName: "Industrie Meridionali S.r.l.",
    numeroREA: "NA-5566778",
    codiceFiscale: "66778899001",
    formaGiuridica: "S.r.l.",
    indirizzoSedeLegale: "Via Napoli 200, 80100 Napoli (NA)",
    tipoCliente: "cedente",
    contattiPersonali: { email: "maria.industria@yahoo.it", phone: "+39 338 5554444" },
    contattiAziendali: { email: "ufficio@indmerid.it", phone: "+39 081 5555 4444" },
    documenti: [
      { id: 1, nome: "Certificato ISO 9001.pdf", tipo: "certificato", dataCaricamento: "2025-01-06", dimensione: "2.3 MB" }
    ]
  },
  { 
    id: 11, 
    name: "Alberto Bianchi", 
    company: "Digital Solutions Ltd.", 
    referredBy: "Laura Bianchi", 
    phone: "+39 02 3333 2222", 
    email: "a.bianchi@digitalsolutions.it",
    vatNumber: "IT77889900112",
    sector: "IT & Digital",
    businessName: "Digital Solutions Ltd.",
    numeroREA: "MI-6677889",
    codiceFiscale: "77889900112",
    formaGiuridica: "S.r.l.",
    indirizzoSedeLegale: "Via Tecnologica 15, 20100 Milano (MI)",
    tipoCliente: "cedente",
    contattiPersonali: { email: "alberto.b@gmail.com", phone: "" },
    contattiAziendali: { email: "info@digitalsolutions.it", phone: "+39 02 3333 2222" },
    documenti: []
  },
  { 
    id: 12, 
    name: "Giulia Pizzeria", 
    company: "Pizzeria Da Mario", 
    referredBy: "Marco Rossi", 
    phone: "+39 06 1111 0000", 
    email: "g.pizzeria@pizzeriadamario.it",
    vatNumber: "IT88990011223",
    sector: "Ristorazione",
    businessName: "Pizzeria Da Mario S.n.c.",
    numeroREA: "RM-7788990",
    codiceFiscale: "88990011223",
    formaGiuridica: "S.n.c.",
    indirizzoSedeLegale: "Via della Pizza 1, 00186 Roma (RM)",
    tipoCliente: "cedente",
    contattiPersonali: { email: "", phone: "+39 320 1110000" },
    contattiAziendali: { email: "ordini@pizzeriadamario.it", phone: "+39 06 1111 0000" },
    documenti: []
  }
];

export const assignmentTypes = [
  { value: 'gestione_affare', label: 'Gestione Affare' },
  { value: 'gestione_cliente', label: 'Gestione Cliente' },
  { value: 'documentazione', label: 'Documentazione' },
  { value: 'altro', label: 'Altro' }
];

export const assignments = [
  // Richieste inviate da Marco Rossi (currentUser)
  {
    id: 1,
    sender: "Marco Rossi",
    senderId: 1,
    recipients: ["Laura Bianchi", "Giuseppe Verdi"],
    recipientIds: [2, 3],
    description: "Preparare analisi patrimoniale per cliente Marini S.r.l.",
    type: "gestione_cliente",
    urgency: "alta",
    dueDate: "2025-07-15",
    status: "in_corso",
    attachments: [
      { id: 101, name: "Bilancio_Marini_2024.pdf", size: 2458624, type: "application/pdf", uploadedAt: "2025-07-10T09:00:00", uploadedBy: "Marco Rossi" }
    ],
    comments: [
      { id: 1, author: "Laura Bianchi", text: "Ho iniziato la raccolta dati", date: "2025-07-10" }
    ],
    createdAt: "2025-07-08T14:30:00"
  },
  {
    id: 2,
    sender: "Marco Rossi",
    senderId: 1,
    recipients: ["Sofia Romano"],
    recipientIds: [4],
    description: "Revisione contratto cessione crediti Costa Holding",
    type: "gestione_affare",
    urgency: "media",
    dueDate: "2025-07-20",
    status: "in_corso",
    attachments: [],
    comments: [],
    createdAt: "2025-07-05T10:00:00"
  },
  {
    id: 3,
    sender: "Marco Rossi",
    senderId: 1,
    recipients: ["Andrea Ferrari", "Laura Bianchi"],
    recipientIds: [5, 2],
    description: "Consulenza fiscale per operazione Galli & Partners",
    type: "gestione_affare",
    urgency: "bassa",
    dueDate: "2025-07-25",
    status: "in_attesa",
    attachments: [
      { id: 102, name: "Proposta_Fiscale_Galli.docx", size: 1245678, type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document", uploadedAt: "2025-07-11T11:00:00", uploadedBy: "Marco Rossi" },
      { id: 103, name: "Dichiarazione_IVA_2024.pdf", size: 567890, type: "application/pdf", uploadedAt: "2025-07-12T09:30:00", uploadedBy: "Andrea Ferrari" }
    ],
    comments: [
      { id: 1, author: "Andrea Ferrari", text: "Documentazione ricevuta", date: "2025-07-11" },
      { id: 2, author: "Laura Bianchi", text: "In attesa di chiarimenti", date: "2025-07-12" }
    ],
    createdAt: "2025-07-03T16:00:00"
  },
  // Incarichi ricevuti da altri per Marco Rossi
  {
    id: 4,
    sender: "Laura Bianchi",
    senderId: 2,
    recipients: ["Marco Rossi"],
    recipientIds: [1],
    description: "Verifica documentazione fiscale cliente Costa Holding",
    type: "documentazione",
    urgency: "alta",
    dueDate: "2025-07-18",
    status: "in_corso",
    attachments: [
      { id: 104, name: "Documentazione_Costa.zip", size: 8567890, type: "application/zip", uploadedAt: "2025-07-12T08:00:00", uploadedBy: "Laura Bianchi" }
    ],
    comments: [
      { id: 1, author: "Marco Rossi", text: "Documentazione ricevuta, procedo con l'analisi", date: "2025-07-12" }
    ],
    createdAt: "2025-07-10T09:00:00"
  },
  {
    id: 5,
    sender: "Sofia Romano",
    senderId: 4,
    recipients: ["Marco Rossi", "Andrea Ferrari"],
    recipientIds: [1, 5],
    description: "Supporto per due diligence legale Ricci Invest",
    type: "gestione_affare",
    urgency: "media",
    dueDate: "2025-07-22",
    status: "in_corso",
    attachments: [],
    comments: [],
    createdAt: "2025-07-06T11:30:00"
  },
  {
    id: 6,
    sender: "Giuseppe Verdi",
    senderId: 3,
    recipients: ["Marco Rossi"],
    recipientIds: [1],
    description: "Preparare presentazione commerciale per nuovo prospect",
    type: "gestione_cliente",
    urgency: "alta",
    dueDate: "2025-07-16",
    status: "da_accettare",
    attachments: [],
    comments: [],
    createdAt: "2025-07-14T14:00:00"
  },
  {
    id: 7,
    sender: "Andrea Ferrari",
    senderId: 5,
    recipients: ["Marco Rossi"],
    recipientIds: [1],
    description: "Review strategia fiscale internazionale Lombardi Capital",
    type: "gestione_cliente",
    urgency: "media",
    dueDate: "2025-07-25",
    status: "da_accettare",
    attachments: [
      { id: 105, name: "Strategia_Fiscale_Lombardi.pdf", size: 3456789, type: "application/pdf", uploadedAt: "2025-07-13T10:00:00", uploadedBy: "Andrea Ferrari" }
    ],
    comments: [
      { id: 1, author: "Andrea Ferrari", text: "Ho allegato la documentazione preliminare", date: "2025-07-13" }
    ],
    createdAt: "2025-07-13T10:00:00"
  },
  {
    id: 8,
    sender: "Laura Bianchi",
    senderId: 2,
    recipients: ["Marco Rossi"],
    recipientIds: [1],
    description: "Validazione budget Q3 prima dell'approvazione finale",
    type: "documentazione",
    urgency: "bassa",
    dueDate: "2025-07-30",
    status: "da_accettare",
    attachments: [],
    comments: [],
    createdAt: "2025-07-15T09:00:00"
  },
  // Incarichi completati
  {
    id: 9,
    sender: "Marco Rossi",
    senderId: 1,
    recipients: ["Laura Bianchi"],
    recipientIds: [2],
    description: "Preparare report mensile vendite Q2 2025",
    type: "documentazione",
    urgency: "alta",
    dueDate: "2025-06-30",
    status: "completato",
    attachments: [
      { id: 106, name: "Report_Vendite_Q2_2025.pdf", size: 1234567, type: "application/pdf", uploadedAt: "2025-06-28T16:00:00", uploadedBy: "Laura Bianchi" }
    ],
    comments: [
      { id: 1, author: "Laura Bianchi", text: "Report completato e allegato", date: "2025-06-28" },
      { id: 2, author: "Marco Rossi", text: "Ottimo lavoro, grazie!", date: "2025-06-29" }
    ],
    createdAt: "2025-06-15T10:00:00",
    completedAt: "2025-06-29T09:00:00"
  },
  {
    id: 10,
    sender: "Sofia Romano",
    senderId: 4,
    recipients: ["Marco Rossi"],
    recipientIds: [1],
    description: "Revisione contratto di riservatezza cliente Galli",
    type: "gestione_cliente",
    urgency: "media",
    dueDate: "2025-06-20",
    status: "completato",
    attachments: [
      { id: 107, name: "NDA_Galli_Firmato.pdf", size: 890123, type: "application/pdf", uploadedAt: "2025-06-18T14:30:00", uploadedBy: "Marco Rossi" }
    ],
    comments: [
      { id: 1, author: "Marco Rossi", text: "Revisione completata, nessuna modifica necessaria", date: "2025-06-18" },
      { id: 2, author: "Sofia Romano", text: "Perfetto, procedo con la firma", date: "2025-06-19" }
    ],
    createdAt: "2025-06-10T11:00:00",
    completedAt: "2025-06-19T16:00:00"
  },
  {
    id: 11,
    sender: "Marco Rossi",
    senderId: 1,
    recipients: ["Giuseppe Verdi", "Andrea Ferrari"],
    recipientIds: [3, 5],
    description: "Analisi fiscale preliminare per acquisizione TechStart",
    type: "gestione_affare",
    urgency: "alta",
    dueDate: "2025-05-31",
    status: "completato",
    attachments: [
      { id: 108, name: "Analisi_TechStart.xlsx", size: 2345678, type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", uploadedAt: "2025-05-28T10:00:00", uploadedBy: "Andrea Ferrari" },
      { id: 109, name: "Relazione_Finale_TechStart.pdf", size: 1567890, type: "application/pdf", uploadedAt: "2025-05-30T15:00:00", uploadedBy: "Giuseppe Verdi" }
    ],
    comments: [
      { id: 1, author: "Andrea Ferrari", text: "Analisi fiscale completata", date: "2025-05-28" },
      { id: 2, author: "Giuseppe Verdi", text: "Relazione finale pronta", date: "2025-05-30" },
      { id: 3, author: "Marco Rossi", text: "Eccellente lavoro di squadra!", date: "2025-05-31" }
    ],
    createdAt: "2025-05-15T09:00:00",
    completedAt: "2025-05-31T11:00:00"
  },
  {
    id: 12,
    sender: "Laura Bianchi",
    senderId: 2,
    recipients: ["Marco Rossi"],
    recipientIds: [1],
    description: "Verifica compliance GDPR documentazione clienti",
    type: "documentazione",
    urgency: "bassa",
    dueDate: "2025-05-15",
    status: "completato",
    attachments: [],
    comments: [
      { id: 1, author: "Marco Rossi", text: "Verifica completata, tutto conforme", date: "2025-05-14" }
    ],
    createdAt: "2025-05-01T14:00:00",
    completedAt: "2025-05-14T17:00:00"
  }
];

// Stages per Proposte Affari
export const proposalStages = [
  "Posizioni da gestire",
  "Offerte fatte al cliente",
  "Accettazione offerta cedente",
  "Firma contratto e CSV"
];

// Stages per Affari in Corso e Completati
export const dealStages = [
  "Mandato",
  "Due diligence",
  "Pagamento cessionario",
  "Fattura golden linx",
  "Incasso della fattura",
  "Pagamento dei fornitori"
];

export const dealsInProgress = [
  {
    id: 1,
    name: "Cessione Crediti Formazione 4.0",
    client: "Manifatture Rossi S.p.A.",
    clientContact: "Paolo Manfredi",
    clientEmail: "p.manfredi@manifatturerossi.it",
    clientPhone: "+39 02 8765 4321",
    tipoAffare: "Cessione Crediti Fiscali",
    urgency: "media",
    value: "€185.000",
    stage: "Mandato",
    assignee: "Giuseppe Verdi",
    teamCoinvolto: ["Laura Bianchi", "Marco Rossi"],
    notes: "Preparazione documentazione mandato e privacy.",
    origineAffare: "Referral da Marco Rossi",
    dataInizio: "2025-05-15",
    dataPagamento: "2025-08-30",
    dilazionamento: {
      rate: 3,
      importoRata: "€61.666",
      scadenze: ["2025-08-30", "2025-09-30", "2025-10-30"]
    },
    commenti: [
      { id: 1, autore: "Giuseppe Verdi", data: "2025-05-16T10:30:00", testo: "Primo contatto con il cliente avvenuto. Documentazione richiesta.", risposte: [] },
      { id: 2, autore: "Laura Bianchi", data: "2025-05-18T14:15:00", testo: "Ricevuta documentazione preliminare. Avvio analisi.", risposte: [
        { id: 21, autore: "Giuseppe Verdi", data: "2025-05-18T15:00:00", testo: "Ottimo, procediamo con la due diligence." }
      ]}
    ]
  },
  {
    id: 2,
    name: "Cessione Crediti Energia Rinnovabile",
    client: "EcoEnergy S.p.A.",
    clientContact: "Luca Verde",
    clientEmail: "l.verde@ecoenergy.it",
    clientPhone: "+39 055 1234 5678",
    tipoAffare: "Cessione Crediti Energia",
    urgency: "alta",
    value: "€720.000",
    stage: "Mandato",
    assignee: "Sofia Romano",
    teamCoinvolto: ["Andrea Ferrari"],
    notes: "Mandato in fase di redazione con consulente legale.",
    origineAffare: "Contatto diretto",
    dataInizio: "2025-06-01",
    dataPagamento: "2025-09-15",
    dilazionamento: {
      rate: 1,
      importoRata: "€720.000",
      scadenze: ["2025-09-15"]
    },
    commenti: [
      { id: 1, autore: "Sofia Romano", data: "2025-06-02T09:00:00", testo: "Cliente molto interessato, richiede tempi rapidi.", risposte: [] }
    ]
  },
  {
    id: 3,
    name: "Cessione Crediti Commerciali",
    client: "Francesca Costa",
    clientContact: "Francesca Costa",
    clientEmail: "f.costa@costaholding.it",
    clientPhone: "+39 06 9876 5432",
    tipoAffare: "Cessione Crediti Commerciali",
    urgency: "alta",
    value: "€450.000",
    stage: "Due diligence",
    assignee: "Sofia Romano",
    teamCoinvolto: ["Laura Bianchi"],
    notes: "Documentazione in verifica",
    origineAffare: "Cliente esistente",
    dataInizio: "2025-04-20",
    dataPagamento: "2025-07-31",
    dilazionamento: {
      rate: 2,
      importoRata: "€225.000",
      scadenze: ["2025-07-31", "2025-08-31"]
    },
    commenti: [
      { id: 1, autore: "Sofia Romano", data: "2025-04-21T11:00:00", testo: "Avviata due diligence. Attesa documentazione integrativa.", risposte: [] }
    ]
  },
  {
    id: 4,
    name: "Cessione Crediti Fiscali IVA",
    client: "Giovanni Marini",
    clientContact: "Giovanni Marini",
    clientEmail: "g.marini@marini.it",
    clientPhone: "+39 02 1234 5678",
    tipoAffare: "Cessione Crediti IVA",
    urgency: "media",
    value: "€1.200.000",
    stage: "Pagamento cessionario",
    assignee: "Laura Bianchi",
    teamCoinvolto: ["Marco Rossi", "Giuseppe Verdi"],
    notes: "Pagamento in attesa di conferma",
    origineAffare: "Referral da Giuseppe Verdi",
    dataInizio: "2025-03-10",
    dataPagamento: "2025-06-30",
    dilazionamento: {
      rate: 4,
      importoRata: "€300.000",
      scadenze: ["2025-06-30", "2025-07-30", "2025-08-30", "2025-09-30"]
    },
    commenti: [
      { id: 1, autore: "Laura Bianchi", data: "2025-03-11T16:00:00", testo: "Pratica di grande valore. Necessaria attenzione particolare.", risposte: [
        { id: 11, autore: "Marco Rossi", data: "2025-03-12T09:30:00", testo: "Concordo, ho schedulato un meeting con il cliente." }
      ]}
    ]
  },
  {
    id: 5,
    name: "Cessione Crediti R&D",
    client: "Roberto Galli",
    clientContact: "Roberto Galli",
    clientEmail: "r.galli@gallipartners.com",
    clientPhone: "+39 011 2468 1357",
    tipoAffare: "Cessione Crediti R&D",
    urgency: "bassa",
    value: "€325.000",
    stage: "Fattura golden linx",
    assignee: "Andrea Ferrari",
    teamCoinvolto: [],
    notes: "Fattura emessa in data odierna",
    origineAffare: "Network professionale",
    dataInizio: "2025-02-15",
    dataPagamento: "2025-05-15",
    dilazionamento: {
      rate: 1,
      importoRata: "€325.000",
      scadenze: ["2025-05-15"]
    },
    commenti: []
  },
  {
    id: 6,
    name: "Cessione Crediti Superbonus",
    client: "Elena Ricci",
    clientContact: "Elena Ricci",
    clientEmail: "e.ricci@ricciinvest.eu",
    clientPhone: "+39 051 3691 2580",
    tipoAffare: "Cessione Crediti Superbonus",
    urgency: "alta",
    value: "€780.000",
    stage: "Incasso della fattura",
    assignee: "Sofia Romano",
    teamCoinvolto: ["Laura Bianchi"],
    notes: "In attesa di bonifico",
    origineAffare: "Referral da Sofia Romano",
    dataInizio: "2025-01-20",
    dataPagamento: "2025-04-20",
    dilazionamento: {
      rate: 2,
      importoRata: "€390.000",
      scadenze: ["2025-04-20", "2025-05-20"]
    },
    commenti: [
      { id: 1, autore: "Sofia Romano", data: "2025-01-21T10:00:00", testo: "Pratica Superbonus complessa ma ben documentata.", risposte: [] }
    ]
  },
  {
    id: 7,
    name: "Cessione Crediti Formazione",
    client: "Marco Lombardi",
    clientContact: "Marco Lombardi",
    clientEmail: "m.lombardi@lombardicap.it",
    clientPhone: "+39 02 7531 9864",
    tipoAffare: "Cessione Crediti Formazione",
    urgency: "media",
    value: "€165.000",
    stage: "Pagamento dei fornitori",
    assignee: "Andrea Ferrari",
    teamCoinvolto: [],
    notes: "Preparazione bonifici fornitori",
    origineAffare: "Contatto diretto",
    dataInizio: "2025-04-01",
    dataPagamento: "2025-07-01",
    dilazionamento: {
      rate: 1,
      importoRata: "€165.000",
      scadenze: ["2025-07-01"]
    },
    commenti: []
  },
  {
    id: 8,
    name: "Cessione Crediti Energia",
    client: "TechStart S.r.l.",
    clientContact: "Anna Startup",
    clientEmail: "a.startup@techstart.io",
    clientPhone: "+39 02 9999 8888",
    tipoAffare: "Cessione Crediti Energia",
    urgency: "alta",
    value: "€520.000",
    stage: "Due diligence",
    assignee: "Giuseppe Verdi",
    teamCoinvolto: ["Sofia Romano"],
    notes: "Analisi preliminare in corso",
    origineAffare: "Evento networking",
    dataInizio: "2025-05-25",
    dataPagamento: "2025-08-25",
    dilazionamento: {
      rate: 3,
      importoRata: "€173.333",
      scadenze: ["2025-08-25", "2025-09-25", "2025-10-25"]
    },
    commenti: [
      { id: 1, autore: "Giuseppe Verdi", data: "2025-05-26T14:00:00", testo: "Startup promettente, crediti energia interessanti.", risposte: [] }
    ]
  }
];

export const dealsCompleted = [
  {
    id: 101,
    name: "Cessione Crediti IVA 2024",
    client: "Giovanni Marini",
    clientContact: "Giovanni Marini",
    clientEmail: "g.marini@marini.it",
    clientPhone: "+39 02 1234 5678",
    tipoAffare: "Cessione Crediti IVA",
    value: "€320.000",
    completedDate: "2025-06-15",
    stage: "Pagamento dei fornitori",
    assignee: "Sofia Romano",
    teamCoinvolto: ["Marco Rossi"],
    notes: "Pratica completata con successo",
    paymentStatus: "saldato",
    origineAffare: "Cliente esistente",
    dataInizio: "2025-01-10",
    dataPagamento: "2025-06-15",
    dilazionamento: {
      rate: 2,
      importoRata: "€160.000",
      scadenze: ["2025-05-15", "2025-06-15"]
    },
    commenti: [
      { id: 1, autore: "Sofia Romano", data: "2025-01-11T10:00:00", testo: "Avviata pratica cessione IVA.", risposte: [] },
      { id: 2, autore: "Marco Rossi", data: "2025-06-15T16:00:00", testo: "Pratica completata con successo!", risposte: [] }
    ]
  },
  {
    id: 102,
    name: "Cessione Crediti Ricerca",
    client: "Francesca Costa",
    clientContact: "Francesca Costa",
    clientEmail: "f.costa@costaholding.it",
    clientPhone: "+39 06 9876 5432",
    tipoAffare: "Cessione Crediti R&D",
    value: "€850.000",
    completedDate: "2025-03-31",
    stage: "Pagamento dei fornitori",
    assignee: "Laura Bianchi",
    teamCoinvolto: ["Giuseppe Verdi", "Andrea Ferrari"],
    notes: "Tutti i pagamenti effettuati",
    paymentStatus: "saldato",
    origineAffare: "Referral da Giuseppe Verdi",
    dataInizio: "2024-11-15",
    dataPagamento: "2025-03-31",
    dilazionamento: {
      rate: 1,
      importoRata: "€850.000",
      scadenze: ["2025-03-31"]
    },
    commenti: [
      { id: 1, autore: "Laura Bianchi", data: "2024-11-16T09:00:00", testo: "Pratica R&D di alto valore. Ottima opportunità.", risposte: [
        { id: 11, autore: "Giuseppe Verdi", data: "2024-11-16T11:30:00", testo: "Cliente affidabile, procediamo." }
      ]},
      { id: 2, autore: "Laura Bianchi", data: "2025-03-31T17:00:00", testo: "Pratica conclusa con successo.", risposte: [] }
    ]
  },
  {
    id: 103,
    name: "Cessione Crediti Edilizi",
    client: "Roberto Galli",
    clientContact: "Roberto Galli",
    clientEmail: "r.galli@gallipartners.com",
    clientPhone: "+39 011 2468 1357",
    tipoAffare: "Cessione Crediti Edilizi",
    value: "€418.500",
    completedDate: "2025-02-28",
    stage: "Pagamento dei fornitori",
    assignee: "Andrea Ferrari",
    teamCoinvolto: [],
    notes: "Operazione conclusa",
    paymentStatus: "da_saldare",
    origineAffare: "Network professionale",
    dataInizio: "2024-10-01",
    dataPagamento: "2025-03-15",
    dilazionamento: {
      rate: 3,
      importoRata: "€139.500",
      scadenze: ["2025-01-15", "2025-02-15", "2025-03-15"]
    },
    commenti: [
      { id: 1, autore: "Andrea Ferrari", data: "2024-10-02T14:00:00", testo: "Avviata pratica crediti edilizi.", risposte: [] }
    ]
  },
  {
    id: 104,
    name: "Cessione Crediti Transizione 4.0",
    client: "Marco Lombardi",
    clientContact: "Marco Lombardi",
    clientEmail: "m.lombardi@lombardicap.it",
    clientPhone: "+39 02 7531 9864",
    tipoAffare: "Cessione Crediti Transizione 4.0",
    value: "€195.000",
    completedDate: "2025-05-20",
    stage: "Pagamento dei fornitori",
    assignee: "Giuseppe Verdi",
    teamCoinvolto: ["Sofia Romano"],
    notes: "Chiusura regolare",
    paymentStatus: "da_saldare",
    origineAffare: "Contatto diretto",
    dataInizio: "2025-02-01",
    dataPagamento: "2025-06-01",
    dilazionamento: {
      rate: 1,
      importoRata: "€195.000",
      scadenze: ["2025-06-01"]
    },
    commenti: [
      { id: 1, autore: "Giuseppe Verdi", data: "2025-02-02T10:00:00", testo: "Cliente interessato a Transizione 4.0.", risposte: [] }
    ]
  }
];

// Eventi Calendario
export const calendarEvents = [
  {
    id: 1,
    title: "Meeting Cliente Marini",
    description: "Discussione portafoglio investimenti Q4",
    date: "2025-11-28",
    time: "10:00",
    duration: "1h",
    type: "meeting",
    attendees: ["Marco Rossi", "Laura Bianchi", "Giovanni Marini"],
    location: "Ufficio Milano",
    priority: "alta"
  },
  {
    id: 2,
    title: "Scadenza Presentazione Offerta",
    description: "Cessione crediti Costa Holding",
    date: "2025-11-29",
    time: "17:00",
    duration: "N/A",
    type: "deadline",
    attendees: ["Sofia Romano"],
    location: "Online",
    priority: "alta"
  },
  {
    id: 3,
    title: "Revisione Trimestrale Team",
    description: "Analisi performance e obiettivi Q4",
    date: "2025-12-02",
    time: "14:30",
    duration: "2h",
    type: "internal",
    attendees: ["Marco Rossi", "Laura Bianchi", "Giuseppe Verdi", "Sofia Romano", "Andrea Ferrari"],
    location: "Sala Conferenze",
    priority: "media"
  },
  {
    id: 4,
    title: "Formazione Compliance",
    description: "Aggiornamento normative fiscali 2026",
    date: "2025-12-05",
    time: "09:00",
    duration: "3h",
    type: "training",
    attendees: ["Tutti"],
    location: "Online - Webinar",
    priority: "bassa"
  },
  {
    id: 5,
    title: "Call con Ricci Invest",
    description: "Follow-up gestione patrimoniale",
    date: "2025-12-08",
    time: "11:00",
    duration: "45min",
    type: "meeting",
    attendees: ["Laura Bianchi", "Elena Ricci"],
    location: "Video Call",
    priority: "media"
  },
  {
    id: 6,
    title: "Firma Contratto TechStart",
    description: "Finalizzazione cessione crediti R&D",
    date: "2025-12-10",
    time: "15:00",
    duration: "1h 30min",
    type: "meeting",
    attendees: ["Marco Rossi", "Sofia Romano"],
    location: "Ufficio Cliente",
    priority: "alta"
  },
  {
    id: 7,
    title: "Scadenza Due Diligence",
    description: "Completamento verifica documenti GlobalTrade",
    date: "2025-12-12",
    time: "18:00",
    duration: "N/A",
    type: "deadline",
    attendees: ["Andrea Ferrari", "Giuseppe Verdi"],
    location: "N/A",
    priority: "alta"
  },
  {
    id: 8,
    title: "Riunione Strategica Mensile",
    description: "Pianificazione dicembre e review novembre",
    date: "2025-12-15",
    time: "10:00",
    duration: "2h",
    type: "internal",
    attendees: ["Marco Rossi", "Laura Bianchi", "Giuseppe Verdi", "Sofia Romano", "Andrea Ferrari"],
    location: "Sala Riunioni",
    priority: "alta"
  },
  {
    id: 9,
    title: "Webinar Cessione Crediti 2026",
    description: "Novità legislative e best practices",
    date: "2025-12-18",
    time: "14:00",
    duration: "2h",
    type: "training",
    attendees: ["Tutti"],
    location: "Online",
    priority: "media"
  },
  {
    id: 10,
    title: "Meeting Lombardi Capital",
    description: "Presentazione servizi gestione patrimoniale",
    date: "2025-12-20",
    time: "11:30",
    duration: "1h",
    type: "meeting",
    attendees: ["Laura Bianchi", "Marco Lombardi"],
    location: "Video Call",
    priority: "media"
  },
  {
    id: 11,
    title: "Verifica Mensile Affari",
    description: "Status check tutti gli affari in corso",
    date: "2025-12-22",
    time: "09:00",
    duration: "1h 30min",
    type: "internal",
    attendees: ["Marco Rossi", "Sofia Romano", "Giuseppe Verdi"],
    location: "Sala Conferenze",
    priority: "media"
  },
  {
    id: 12,
    title: "Scadenza Pagamento Fornitori",
    description: "Bonifici affari completati novembre",
    date: "2025-12-27",
    time: "16:00",
    duration: "N/A",
    type: "deadline",
    attendees: ["Andrea Ferrari"],
    location: "N/A",
    priority: "alta"
  },
  {
    id: 11,
    title: "Incasso Rata Costa Holding",
    description: "Incasso seconda rata da Francesca Costa - €8.333",
    date: "2025-04-01",
    time: "10:00",
    duration: "N/A",
    type: "incasso",
    attendees: ["Laura Bianchi"],
    location: "N/A",
    priority: "alta"
  },
  {
    id: 12,
    title: "Incasso Fattura Marini",
    description: "Incasso fattura consulenza fiscale - €15.000",
    date: "2025-02-15",
    time: "09:00",
    duration: "N/A",
    type: "incasso",
    attendees: ["Marco Rossi", "Laura Bianchi"],
    location: "N/A",
    priority: "alta"
  },
  {
    id: 13,
    title: "Pagamento Fornitori",
    description: "Pagamento fatture fornitori mensili",
    date: "2025-01-05",
    time: "14:00",
    duration: "N/A",
    type: "pagamento",
    attendees: ["Laura Bianchi"],
    location: "N/A",
    priority: "media"
  },
  {
    id: 14,
    title: "Pagamento Consulente Esterno",
    description: "Pagamento consulenza legale - €3.500",
    date: "2025-01-20",
    time: "11:00",
    duration: "N/A",
    type: "pagamento",
    attendees: ["Sofia Romano", "Laura Bianchi"],
    location: "N/A",
    priority: "media"
  }
];

export const eventTypes = [
  { value: "all", label: "Tutti gli Eventi" },
  { value: "meeting", label: "Meeting" },
  { value: "deadline", label: "Scadenze" },
  { value: "internal", label: "Eventi Interni" },
  { value: "training", label: "Formazione" },
  { value: "incasso", label: "Incasso" },
  { value: "pagamento", label: "Pagamento" }
];

// Documenti
export const documents = [
  {
    id: 1,
    name: "Contratto_Marini_GP_2025.pdf",
    type: "contratto",
    size: "2.4 MB",
    uploadDate: "2025-06-15",
    uploadedBy: "Laura Bianchi",
    client: "Giovanni Marini",
    category: "Contratto",
    status: "firmato"
  },
  {
    id: 2,
    name: "Bilancio_Aziendale_Q1_2025.xlsx",
    type: "bilancio",
    size: "890 KB",
    uploadDate: "2025-04-02",
    uploadedBy: "Andrea Ferrari",
    client: "Interno",
    category: "Mandato di assistenza",
    status: "approvato"
  },
  {
    id: 3,
    name: "Proposta_Cessione_Costa.pdf",
    type: "proposta",
    size: "1.8 MB",
    uploadDate: "2025-07-10",
    uploadedBy: "Sofia Romano",
    client: "Francesca Costa",
    category: "Comfort letter",
    status: "in_revisione"
  },
  {
    id: 4,
    name: "Due_Diligence_Galli_Partners.pdf",
    type: "analisi",
    size: "5.2 MB",
    uploadDate: "2025-06-28",
    uploadedBy: "Giuseppe Verdi",
    client: "Roberto Galli",
    category: "Contratto",
    status: "completato"
  },
  {
    id: 5,
    name: "Fattura_2025_0145.pdf",
    type: "fattura",
    size: "320 KB",
    uploadDate: "2025-06-20",
    uploadedBy: "Marco Rossi",
    client: "Giovanni Marini",
    category: "Mandato di assistenza",
    status: "pagata"
  }
];

// Contabilità Aziendale
export const companyAccounting = {
  overview: {
    currentBalance: "€458,750",
    monthlyRevenue: "€125,300",
    monthlyExpenses: "€78,450",
    netProfit: "€46,850",
    yearToDateRevenue: "€847,200",
    yearToDateExpenses: "€523,800",
    yearToDateProfit: "€323,400"
  },
  recentTransactions: [
    {
      id: 1,
      date: "2025-07-12",
      description: "Incasso Fattura INV-2025-0145",
      category: "Entrata",
      amount: "€320,000",
      type: "income",
      client: "Giovanni Marini"
    },
    {
      id: 2,
      date: "2025-07-10",
      description: "Stipendi Staff Luglio",
      category: "Spesa Personale",
      amount: "-€42,500",
      type: "expense",
      client: "N/A"
    },
    {
      id: 3,
      date: "2025-07-08",
      description: "Affitto Ufficio",
      category: "Spesa Operativa",
      amount: "-€8,500",
      type: "expense",
      client: "N/A"
    },
    {
      id: 4,
      date: "2025-07-05",
      description: "Incasso Fattura INV-2025-0142",
      category: "Entrata",
      amount: "€85,000",
      type: "income",
      client: "Francesca Costa"
    },
    {
      id: 5,
      date: "2025-07-03",
      description: "Software e Licenze",
      category: "Spesa IT",
      amount: "-€3,200",
      type: "expense",
      client: "N/A"
    }
  ],
  expenses: [
    { category: "Personale", amount: 42500, percentage: 54 },
    { category: "Affitto & Utenze", amount: 12000, percentage: 15 },
    { category: "Marketing", amount: 8500, percentage: 11 },
    { category: "IT & Software", amount: 6200, percentage: 8 },
    { category: "Consulenze Esterne", amount: 5500, percentage: 7 },
    { category: "Altro", amount: 3750, percentage: 5 }
  ]
};

// Proposte Affari
export const dealProposals = [
  {
    id: 1,
    name: "Cessione Crediti R&D TechInnovate",
    client: "Alberto Bianchi",
    clientContact: "Alberto Bianchi",
    clientEmail: "a.bianchi@techinnovate.com",
    clientPhone: "+39 02 3333 2222",
    tipoAffare: "Cessione Crediti R&D",
    estimatedValue: "€2,500,000",
    stage: "Posizioni da gestire",
    assignee: "Laura Bianchi",
    teamCoinvolto: ["Marco Rossi", "Giuseppe Verdi"],
    notes: "Cliente ha richiesto valutazione preliminare. Documentazione in raccolta.",
    priority: "alta",
    proposalDate: "2025-07-08",
    origineAffare: "Evento Tech Milano",
    dataInizio: "2025-07-08",
    dataPagamentoPrevista: "2025-10-30",
    dilazionamento: {
      rate: 4,
      importoRata: "€625.000",
      scadenze: ["2025-10-30", "2025-11-30", "2025-12-30", "2026-01-30"]
    },
    commenti: [
      { id: 1, autore: "Laura Bianchi", data: "2025-07-08T16:00:00", testo: "Proposta di grande valore. Cliente molto interessato.", risposte: [
        { id: 11, autore: "Marco Rossi", data: "2025-07-09T09:00:00", testo: "Confermo, ho verificato la documentazione preliminare." }
      ]}
    ]
  },
  {
    id: 2,
    name: "Cessione Crediti IVA Q2 2025",
    client: "TechStart S.r.l.",
    clientContact: "Anna Startup",
    clientEmail: "info@techstart.it",
    clientPhone: "+39 02 9999 8888",
    tipoAffare: "Cessione Crediti IVA",
    estimatedValue: "€180,000",
    stage: "Offerte fatte al cliente",
    assignee: "Sofia Romano",
    teamCoinvolto: [],
    notes: "Offerta inviata con condizioni vantaggiose. In attesa di risposta.",
    priority: "media",
    proposalDate: "2025-07-11",
    origineAffare: "Referral da cliente esistente",
    dataInizio: "2025-07-11",
    dataPagamentoPrevista: "2025-09-30",
    dilazionamento: {
      rate: 1,
      importoRata: "€180.000",
      scadenze: ["2025-09-30"]
    },
    commenti: [
      { id: 1, autore: "Sofia Romano", data: "2025-07-11T10:00:00", testo: "Offerta inviata. Attendo riscontro entro fine settimana.", risposte: [] }
    ]
  },
  {
    id: 3,
    name: "Cessione Crediti Superbonus 110%",
    client: "GlobalTrade Inc.",
    clientContact: "Carlo Bianchi",
    clientEmail: "finance@globaltrade.com",
    clientPhone: "+39 06 7777 6666",
    tipoAffare: "Cessione Crediti Superbonus",
    estimatedValue: "€950,000",
    stage: "Accettazione offerta cedente",
    assignee: "Andrea Ferrari",
    teamCoinvolto: ["Laura Bianchi"],
    notes: "Cliente ha accettato verbalmente. In attesa di conferma scritta.",
    priority: "alta",
    proposalDate: "2025-07-05",
    origineAffare: "Contatto diretto",
    dataInizio: "2025-07-05",
    dataPagamentoPrevista: "2025-11-15",
    dilazionamento: {
      rate: 2,
      importoRata: "€475.000",
      scadenze: ["2025-11-15", "2025-12-15"]
    },
    commenti: [
      { id: 1, autore: "Andrea Ferrari", data: "2025-07-05T14:30:00", testo: "Ottimo incontro con il cliente. Molto interessato.", risposte: [] },
      { id: 2, autore: "Laura Bianchi", data: "2025-07-06T11:00:00", testo: "Ho preparato la documentazione per la firma.", risposte: [
        { id: 21, autore: "Andrea Ferrari", data: "2025-07-06T11:30:00", testo: "Perfetto, la invio oggi stesso." }
      ]}
    ]
  },
  {
    id: 4,
    name: "Cessione Crediti Investimenti Sud",
    client: "Pizzeria Da Mario",
    clientContact: "Giulia Pizzeria",
    clientEmail: "damario@email.it",
    clientPhone: "+39 06 1111 0000",
    tipoAffare: "Cessione Crediti Investimenti",
    estimatedValue: "€98,000",
    stage: "Firma contratto e CSV",
    assignee: "Laura Bianchi",
    teamCoinvolto: [],
    notes: "Attesa firma finale e caricamento CSV.",
    priority: "bassa",
    proposalDate: "2025-07-12",
    origineAffare: "Referral da Marco Rossi",
    dataInizio: "2025-07-12",
    dataPagamentoPrevista: "2025-09-15",
    dilazionamento: {
      rate: 1,
      importoRata: "€98.000",
      scadenze: ["2025-09-15"]
    },
    commenti: []
  },
  {
    id: 5,
    name: "Cessione Crediti Transizione Digitale",
    client: "Digital Solutions Ltd.",
    clientContact: "Alberto Bianchi",
    clientEmail: "info@digitalsol.com",
    clientPhone: "+39 02 3333 2222",
    tipoAffare: "Cessione Crediti Transizione Digitale",
    estimatedValue: "€340,000",
    stage: "Posizioni da gestire",
    assignee: "Andrea Ferrari",
    teamCoinvolto: ["Sofia Romano"],
    notes: "Nuovo lead da qualificare.",
    priority: "media",
    proposalDate: "2025-07-14",
    origineAffare: "LinkedIn",
    dataInizio: "2025-07-14",
    dataPagamentoPrevista: "2025-11-30",
    dilazionamento: {
      rate: 2,
      importoRata: "€170.000",
      scadenze: ["2025-11-30", "2025-12-30"]
    },
    commenti: [
      { id: 1, autore: "Andrea Ferrari", data: "2025-07-14T09:00:00", testo: "Nuovo contatto da qualificare. Sembra promettente.", risposte: [] }
    ]
  },
  {
    id: 6,
    name: "Cessione Crediti Beni Strumentali",
    client: "Industrie Meridionali",
    clientContact: "Maria Industria",
    clientEmail: "finance@indmer.it",
    clientPhone: "+39 081 5555 4444",
    tipoAffare: "Cessione Crediti Beni Strumentali",
    estimatedValue: "€1,200,000",
    stage: "Offerte fatte al cliente",
    assignee: "Giuseppe Verdi",
    teamCoinvolto: ["Marco Rossi", "Laura Bianchi"],
    notes: "Presentate due opzioni di cessione. Cliente in valutazione.",
    priority: "alta",
    proposalDate: "2025-07-09",
    origineAffare: "Fiera Napoli",
    dataInizio: "2025-07-09",
    dataPagamentoPrevista: "2025-12-31",
    dilazionamento: {
      rate: 3,
      importoRata: "€400.000",
      scadenze: ["2025-12-31", "2026-01-31", "2026-02-28"]
    },
    commenti: [
      { id: 1, autore: "Giuseppe Verdi", data: "2025-07-09T15:00:00", testo: "Presentate due opzioni. Cliente richiede tempo per decidere.", risposte: [
        { id: 11, autore: "Marco Rossi", data: "2025-07-10T10:00:00", testo: "Possiamo offrire condizioni migliori sulla seconda opzione." }
      ]}
    ]
  }
];


// Fatture e Incassi per Contabilità Gestionale
export const invoices = [
  {
    id: 1,
    invoiceNumber: "FT-2025-001",
    client: "Giovanni Marini",
    clientId: 1,
    assignment: "Consulenza Fiscale 2025",
    assignmentId: 1,
    issueDate: "2025-01-15",
    totalAmount: 15000,
    status: "emessa"
  },
  {
    id: 2,
    invoiceNumber: "FT-2025-002",
    client: "Francesca Costa",
    clientId: 2,
    assignment: "Ottimizzazione Patrimoniale",
    assignmentId: 2,
    issueDate: "2025-02-01",
    totalAmount: 25000,
    status: "emessa"
  },
  {
    id: 3,
    invoiceNumber: "FT-2025-003",
    client: "Roberto Galli",
    clientId: 3,
    assignment: "Consulenza Annuale",
    assignmentId: 3,
    issueDate: "2025-03-10",
    totalAmount: 18000,
    status: "emessa"
  },
  {
    id: 4,
    invoiceNumber: "FT-2025-004",
    client: "Elena Ricci",
    clientId: 4,
    assignment: "Piano Investimenti",
    assignmentId: 4,
    issueDate: "2025-04-05",
    totalAmount: 30000,
    status: "emessa"
  }
];



// Uscite Aziendali
export const expenses = [
  // Stipendi
  {
    id: 1,
    description: "Stipendio Marco Rossi",
    type: "stipendio",
    amount: 4500,
    dueDate: "2025-01-31",
    paymentDate: "2025-01-31",
    status: "pagato",
    recurring: "mensile",
    notes: "Senior Advisor"
  },
  {
    id: 2,
    description: "Stipendio Laura Bianchi",
    type: "stipendio",
    amount: 3800,
    dueDate: "2025-01-31",
    paymentDate: "2025-01-31",
    status: "pagato",
    recurring: "mensile",
    notes: "Financial Analyst"
  },
  {
    id: 3,
    description: "Stipendio Giuseppe Verdi",
    type: "stipendio",
    amount: 3500,
    dueDate: "2025-02-28",
    paymentDate: null,
    status: "da_saldare",
    recurring: "mensile",
    notes: "Account Manager"
  },
  {
    id: 4,
    description: "Stipendio Sofia Romano",
    type: "stipendio",
    amount: 4200,
    dueDate: "2025-02-28",
    paymentDate: null,
    status: "da_saldare",
    recurring: "mensile",
    notes: "Legal Advisor"
  },
  {
    id: 5,
    description: "Stipendio Andrea Ferrari",
    type: "stipendio",
    amount: 4000,
    dueDate: "2025-02-28",
    paymentDate: null,
    status: "da_saldare",
    recurring: "mensile",
    notes: "Tax Consultant"
  },
  // Gestione
  {
    id: 6,
    description: "Affitto ufficio",
    type: "gestione",
    amount: 2500,
    dueDate: "2025-01-05",
    paymentDate: "2025-01-05",
    status: "pagato",
    recurring: "mensile",
    notes: "Via Roma 123"
  },
  {
    id: 7,
    description: "Utenze (luce, gas, acqua)",
    type: "gestione",
    amount: 450,
    dueDate: "2025-01-15",
    paymentDate: "2025-01-15",
    status: "pagato",
    recurring: "mensile",
    notes: ""
  },
  {
    id: 8,
    description: "Software gestionale",
    type: "gestione",
    amount: 300,
    dueDate: "2025-02-01",
    paymentDate: null,
    status: "da_saldare",
    recurring: "mensile",
    notes: "Abbonamento annuale"
  },
  // Spese aziendali
  {
    id: 9,
    description: "Materiale ufficio",
    type: "spesa_aziendale",
    amount: 280,
    dueDate: "2025-01-20",
    paymentDate: "2025-01-20",
    status: "pagato",
    recurring: "una_tantum",
    notes: "Forniture varie"
  },
  {
    id: 10,
    description: "Formazione personale",
    type: "spesa_aziendale",
    amount: 1200,
    dueDate: "2025-03-15",
    paymentDate: null,
    status: "previsto",
    recurring: "una_tantum",
    notes: "Corso aggiornamento fiscale"
  },
  // Pagamenti fornitori
  {
    id: 11,
    description: "Consulente legale esterno",
    type: "pagamento",
    amount: 3500,
    dueDate: "2025-01-20",
    paymentDate: "2025-01-20",
    status: "pagato",
    recurring: "una_tantum",
    notes: "Parere legale pratica Costa"
  },
  {
    id: 12,
    description: "Commercialista esterno",
    type: "pagamento",
    amount: 2200,
    dueDate: "2025-02-10",
    paymentDate: null,
    status: "da_saldare",
    recurring: "trimestrale",
    notes: "Consulenza Q4 2024"
  }
];

export const payments = [
  // Fattura 1 - Incasso unico completato
  {
    id: 1,
    invoiceId: 1,
    invoiceNumber: "FT-2025-001",
    client: "Giovanni Marini",
    clientId: 1,
    assignment: "Consulenza Fiscale 2025",
    amount: 15000,
    dueDate: "2025-02-15",
    paymentDate: "2025-02-10",
    status: "incassato",
    type: "unico",
    notes: "Pagamento anticipato"
  },
  // Fattura 2 - Incassi rateizzati (3 rate)
  {
    id: 2,
    invoiceId: 2,
    invoiceNumber: "FT-2025-002",
    client: "Francesca Costa",
    clientId: 2,
    assignment: "Ottimizzazione Patrimoniale",
    amount: 8333,
    dueDate: "2025-03-01",
    paymentDate: "2025-03-01",
    status: "incassato",
    type: "rateizzato",
    installment: "1/3",
    notes: ""
  },
  {
    id: 3,
    invoiceId: 2,
    invoiceNumber: "FT-2025-002",
    client: "Francesca Costa",
    clientId: 2,
    assignment: "Ottimizzazione Patrimoniale",
    amount: 8333,
    dueDate: "2025-04-01",
    paymentDate: null,
    status: "in_ritardo",
    type: "rateizzato",
    installment: "2/3",
    notes: "Cliente contattato"
  },
  {
    id: 4,
    invoiceId: 2,
    invoiceNumber: "FT-2025-002",
    client: "Francesca Costa",
    clientId: 2,
    assignment: "Ottimizzazione Patrimoniale",
    amount: 8334,
    dueDate: "2025-05-01",
    paymentDate: null,
    status: "previsto",
    type: "rateizzato",
    installment: "3/3",
    notes: ""
  },
  // Fattura 3 - Incassi ricorrenti trimestrali
  {
    id: 5,
    invoiceId: 3,
    invoiceNumber: "FT-2025-003",
    client: "Roberto Galli",
    clientId: 3,
    assignment: "Consulenza Annuale",
    amount: 4500,
    dueDate: "2025-04-10",
    paymentDate: "2025-04-08",
    status: "incassato",
    type: "ricorrente",
    frequency: "trimestrale",
    installment: "1/4",
    notes: ""
  },
  {
    id: 6,
    invoiceId: 3,
    invoiceNumber: "FT-2025-003",
    client: "Roberto Galli",
    clientId: 3,
    assignment: "Consulenza Annuale",
    amount: 4500,
    dueDate: "2025-07-10",
    paymentDate: null,
    status: "previsto",
    type: "ricorrente",
    frequency: "trimestrale",
    installment: "2/4",
    notes: ""
  },
  {
    id: 7,
    invoiceId: 3,
    invoiceNumber: "FT-2025-003",
    client: "Roberto Galli",
    clientId: 3,
    assignment: "Consulenza Annuale",
    amount: 4500,
    dueDate: "2025-10-10",
    paymentDate: null,
    status: "previsto",
    type: "ricorrente",
    frequency: "trimestrale",
    installment: "3/4",
    notes: ""
  },
  {
    id: 8,
    invoiceId: 3,
    invoiceNumber: "FT-2025-003",
    client: "Roberto Galli",
    clientId: 3,
    assignment: "Consulenza Annuale",
    amount: 4500,
    dueDate: "2026-01-10",
    paymentDate: null,
    status: "previsto",
    type: "ricorrente",
    frequency: "trimestrale",
    installment: "4/4",
    notes: ""
  },
  // Fattura 4 - Incasso mensile ricorrente
  {
    id: 9,
    invoiceId: 4,
    invoiceNumber: "FT-2025-004",
    client: "Elena Ricci",
    clientId: 4,
    assignment: "Piano Investimenti",
    amount: 2500,
    dueDate: "2025-05-05",
    paymentDate: null,
    status: "previsto",
    type: "ricorrente",
    frequency: "mensile",
    installment: "1/12",
    notes: ""
  },
  {
    id: 10,
    invoiceId: 4,
    invoiceNumber: "FT-2025-004",
    client: "Elena Ricci",
    clientId: 4,
    assignment: "Piano Investimenti",
    amount: 2500,
    dueDate: "2025-06-05",
    paymentDate: null,
    status: "previsto",
    type: "ricorrente",
    frequency: "mensile",
    installment: "2/12",
    notes: ""
  }
];

